import React, { useState } from 'react';
import './Client.css';

const Client = () => {
  const [viewMode, setViewMode] = useState('marquee'); // 'marquee' or 'grid'

  const clients = [
    {
      name: 'Colombo Dockyard',
      fullName: 'Colombo Dockyard PLC',
      logo: '/images/dockyard.png',
      type: 'Shipyard & Drydock',
    },
    {
      name: 'CMA CGM',
      fullName: 'CMA CGM Shipping Line',
      logo: '/images/cma.png',
      type: 'Global Ocean Carrier',
    },
    {
      name: 'MSC',
      fullName: 'Mediterranean Shipping Company',
      logo: '/images/msc.jpg',
      type: 'Container Shipping Leader',
    },
    {
      name: 'ABB Marine',
      fullName: 'ABB Turbocharging & Power',
      logo: '/images/ABB.png',
      type: 'Marine Propulsion & Power',
    },
    {
      name: 'Skyships',
      fullName: 'Skyships Maritime Operations',
      logo: '/images/skyship.png',
      type: 'Offshore Tug & Fleet',
    },
    {
      name: 'Alpha Global',
      fullName: 'Alpha Global Ship Services',
      logo: '/images/alpha-globle-cropped.png',
      type: 'Technical & Voyage Supply',
    },
  ];

  // Duplicate for seamless 50% infinite translation
  const marqueeClients = [...clients, ...clients];

  const stats = [
    { num: '150+', label: 'Vessels Serviced Annually' },
    { num: '100%', label: 'Class Society Approvals' },
    { num: '24/7', label: 'Afloat Response Teams' },
    { num: '99.4%', label: 'On-Time Project Redelivery' },
  ];

  return (
    <section className="client-section" id="clients">
      {/* Decorative ambient gradients */}
      <div className="client-glow client-glow-1"></div>
      <div className="client-glow client-glow-2"></div>

      <div className="client-container">
        {/* Header */}
        <div className="client-header">
          <div className="client-badge-wrapper">
            <span className="client-badge-dot"></span>
            <span className="client-badge-text">GLOBAL MARITIME NETWORK</span>
          </div>

          <h2 className="client-title">
            Trusted by World-Class{' '}
            <span className="client-title-highlight">Maritime Leaders</span>
          </h2>

          <p className="client-subtitle">
            From major global liner corporations to regional shipyards, leading shipowners rely on BlueWave for critical afloat repairs, technical vessel management, and offshore excellence.
          </p>
        </div>

        {/* Stats Strip */}
        <div className="client-stats-bar">
          {stats.map((stat, sIdx) => (
            <div key={sIdx} className="client-stat-item">
              <div className="client-stat-num">{stat.num}</div>
              <div className="client-stat-label">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Clients Display: Marquee or Grid */}
        {viewMode === 'marquee' ? (
          <div className="client-marquee-wrapper" title="Hover to pause slider">
            <div className="client-marquee-track">
              {marqueeClients.map((client, idx) => (
                <div key={idx} className="client-card">
                  <div className="client-img-box">
                    <img
                      src={client.logo}
                      alt={client.fullName}
                      className={client.scaledUp ? 'logo-scaled-up' : ''}
                      loading="lazy"
                    />
                  </div>
                  <div className="client-card-meta">
                    <span className="client-card-name">{client.name}</span>
                    <span className="client-card-type">{client.type}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="client-grid-wrapper">
            {clients.map((client, idx) => (
              <div key={idx} className="client-card">
                <div className="client-img-box">
                  <img
                    src={client.logo}
                    alt={client.fullName}
                    className={client.scaledUp ? 'logo-scaled-up' : ''}
                    loading="lazy"
                  />
                </div>
                <div className="client-card-meta">
                  <span className="client-card-name">{client.fullName}</span>
                  <span className="client-card-type">{client.type}</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Footer info & view toggler */}
        <div className="client-footer-bar">
          <div className="client-footer-text">
            <svg
              className="client-shield-icon"
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <polyline points="9 12 11 14 15 10" />
            </svg>
            <span>
              Accredited and compliant with <strong>ISO 9001:2015</strong>, <strong>MLC 2006</strong>, and <strong>ISM Code</strong> international standards.
            </span>
          </div>

          <div className="client-view-toggle">
            <button
              className={`client-toggle-btn ${viewMode === 'marquee' ? 'active' : ''}`}
              onClick={() => setViewMode('marquee')}
              aria-label="Continuous Slider View"
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="13 17 18 12 13 7" />
                <polyline points="6 17 11 12 6 7" />
              </svg>
              <span>Auto Slider</span>
            </button>
            <button
              className={`client-toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
              onClick={() => setViewMode('grid')}
              aria-label="Grid View"
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
              </svg>
              <span>Grid View</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Client;
